export default "__VITE_ASSET__Cu2x3R$c__"